export default __webpack_public_path__ + "static/media/img3.3fed7719.JPG";